import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import ReportService from "../../services/ReportService";
import {
  learningMilestoneCountSummaryFail,
  learningMilestoneCountSummarySuccess,
  learningMilestoneItemSummaryFail,
  learningMilestoneItemSummarySuccess,
  learningMilestoneUserExcelFail,
  learningMilestoneUserExcelSuccess,
  learningMilestoneUsersFail,
  learningMilestoneUsersSuccess,
  learningObjectCountSummaryFail,
  learningObjectCountSummarySuccess,
  learningObjectItemSummaryFail,
  learningObjectItemSummarySuccess,
  learningObjectUserExcelFail,
  learningObjectUserExcelSuccess,
  learningObjectUsersFail,
  learningObjectUsersSuccess,
  learningProgramCountSummaryFail,
  learningProgramCountSummarySuccess,
  learningProgramItemSummaryFail,
  learningProgramItemSummarySuccess,
  learningProgramUserExcelFail,
  learningProgramUserExcelSuccess,
  learningProgramUsersFail,
  learningProgramUsersSuccess,
} from "../slices/reportSlice";

function* learningObjectCountSummary(data) {
  try {
    const ajax = yield call(
      ReportService.learningObjectCountSummary,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningObjectCountSummarySuccess(ajax.data));
    } else {
      yield put(
        learningObjectCountSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningObjectCountSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningObjectsSummary(data) {
  try {
    const ajax = yield call(ReportService.learningObjectsSummary, data.payload);
    if (ajax.status === 200) {
      yield put(learningObjectItemSummarySuccess(ajax.data));
    } else {
      yield put(
        learningObjectItemSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningObjectItemSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningObjectsUsers(data) {
  try {
    const ajax = yield call(ReportService.learningObjectsUsers, data.payload);
    if (ajax.status === 200) {
      yield put(learningObjectUsersSuccess(ajax.data));
    } else {
      yield put(
        learningObjectUsersFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningObjectUsersFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningProgramCountSummary(data) {
  try {
    const ajax = yield call(
      ReportService.learningProgramCountSummary,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningProgramCountSummarySuccess(ajax.data));
    } else {
      yield put(
        learningProgramCountSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramCountSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningProgramsSummary(data) {
  try {
    const ajax = yield call(
      ReportService.learningProgramsSummary,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningProgramItemSummarySuccess(ajax.data));
    } else {
      yield put(
        learningProgramItemSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramItemSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningProgramsUsers(data) {
  try {
    const ajax = yield call(ReportService.learningProgramsUsers, data.payload);
    if (ajax.status === 200) {
      yield put(learningProgramUsersSuccess(ajax.data));
    } else {
      yield put(
        learningProgramUsersFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramUsersFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningMilestoneCountSummary(data) {
  try {
    const ajax = yield call(
      ReportService.learningMilestoneCountSummary,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningMilestoneCountSummarySuccess(ajax.data));
    } else {
      yield put(
        learningMilestoneCountSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningMilestoneCountSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningMilestonesSummary(data) {
  try {
    const ajax = yield call(
      ReportService.learningMilestonesSummary,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningMilestoneItemSummarySuccess(ajax.data));
    } else {
      yield put(
        learningMilestoneItemSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningMilestoneItemSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningMilestonesUsers(data) {
  try {
    const ajax = yield call(
      ReportService.learningMilestonesUsers,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningMilestoneUsersSuccess(ajax.data));
    } else {
      yield put(
        learningMilestoneUsersFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningMilestoneUsersFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningObjectsUsersExcel(data) {
  try {
    const { fileType = "excel" } = data.payload;

    let extension = "xlsx";
    if (fileType === "csv") {
      extension = "csv";
    } else if (fileType === "pdf") {
      extension = "pdf";
    }

    const ajax = yield call(
      ReportService.learningObjectsUsersExcel,
      data.payload
    );
    if (ajax.status === 200) {
      const url = window.URL.createObjectURL(new Blob([ajax.data]), {
        type: ajax.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `learning_object_report.${extension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      yield put(learningObjectUserExcelSuccess());
    } else {
      yield put(
        learningObjectUserExcelFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningObjectUserExcelFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningMilestonesUsersExcel(data) {
  try {
    const { fileType = "excel" } = data.payload;

    let extension = "xlsx";
    if (fileType === "csv") {
      extension = "csv";
    } else if (fileType === "pdf") {
      extension = "pdf";
    }

    const ajax = yield call(
      ReportService.learningMilestonesUsersExcel,
      data.payload
    );
    if (ajax.status === 200) {
      const url = window.URL.createObjectURL(new Blob([ajax.data]), {
        type: ajax.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `learning_milestone_report.${extension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      yield put(learningMilestoneUserExcelSuccess());
    } else {
      yield put(
        learningMilestoneUserExcelFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningMilestoneUserExcelFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningProgramsUsersExcel(data) {
  try {
    const { fileType = "excel" } = data.payload;

    let extension = "xlsx";
    if (fileType === "csv") {
      extension = "csv";
    } else if (fileType === "pdf") {
      extension = "pdf";
    }

    const ajax = yield call(
      ReportService.learningProgramsUsersExcel,
      data.payload
    );
    if (ajax.status === 200) {
      const url = window.URL.createObjectURL(new Blob([ajax.data]), {
        type: ajax.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `learning_program_report.${extension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      yield put(learningProgramUserExcelSuccess());
    } else {
      yield put(
        learningProgramUserExcelFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramUserExcelFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* reportSaga() {
  yield all([
    takeLatest(
      "reports/learningObjectCountSummaryRequest",
      learningObjectCountSummary
    ),
    takeLatest(
      "reports/learningObjectItemSummaryRequest",
      learningObjectsSummary
    ),
    takeLatest("reports/learningObjectUsersRequest", learningObjectsUsers),
    takeLatest(
      "reports/learningProgramCountSummaryRequest",
      learningProgramCountSummary
    ),
    takeLatest(
      "reports/learningProgramItemSummaryRequest",
      learningProgramsSummary
    ),
    takeLatest("reports/learningProgramUsersRequest", learningProgramsUsers),
    takeLatest(
      "reports/learningMilestoneCountSummaryRequest",
      learningMilestoneCountSummary
    ),
    takeLatest(
      "reports/learningMilestoneItemSummaryRequest",
      learningMilestonesSummary
    ),
    takeLatest(
      "reports/learningMilestoneUsersRequest",
      learningMilestonesUsers
    ),
    takeLatest(
      "reports/learningObjectUserExcelRequest",
      learningObjectsUsersExcel
    ),
    takeLatest(
      "reports/learningMilestoneUserExcelRequest",
      learningMilestonesUsersExcel
    ),
    takeLatest(
      "reports/learningProgramUserExcelRequest",
      learningProgramsUsersExcel
    ),
  ]);
}
